import { 
  CREATE_BRANDKIT_COLOR, DELETE_BRANDKIT_COLOR, UPDATE_BRANDKIT_COLOR_PROPERTY, RENAME_BRANDKIT_COLORS,
  FETCHING_BRANDKIT_COLORS_REQUEST, FETCHING_BRANDKIT_COLORS_SUCCEEDED, FETCHING_BRANDKIT_COLORS_FAILED,
  DELETE_BRANDKIT_COLORS_REQUEST, DELETING_BRANDKIT_COLORS_SUCCEEDED, DELETING_BRANDKIT_COLORS_FAILED,
  UPDATE_BRANDKIT_COLORS_REQUEST, UPDATING_BRANDKIT_COLORS_SUCCEEDED, UPDATING_BRANDKIT_COLORS_FAILED,
  INVALIDATE_BRANDKIT_COLORS
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const BRANDKIT_COLORS_URL = `${apiUrl}/api/2.0/palette`;


export const createBrandkitColor = createAction(CREATE_BRANDKIT_COLOR, (component) => {
  return {
    component: component
  };
});

export const deleteBrandkitNewColors = createAction(DELETE_BRANDKIT_COLOR, (ids) => {
  return {
    ids: ids
  };
});

export const updateBrandkitColorProperty = createAction(UPDATE_BRANDKIT_COLOR_PROPERTY, (id, property) => {
  return {
    id: id,
    property: property
  };
});

export const renameBrandkitColors = createAction(RENAME_BRANDKIT_COLORS, (id, name) => {
  return {
    id: id,
    name: name
  };
});

/**
 * Fetch Brankit Colors
*/
  export const fetchBrandkitColors = createAction(FETCHING_BRANDKIT_COLORS_REQUEST, id => {
    return id;
  })
  
  const fetchBrandkitColorsSucceeded = createAction(FETCHING_BRANDKIT_COLORS_SUCCEEDED, response => {
    return response;
  })
  
  const fetchingBrandkitColorsFailed = createAction(FETCHING_BRANDKIT_COLORS_FAILED, (id, error) => {
    return {
      id: id,
      error: error
    }
  })
  
  function* fetchingBrandkitColorsSaga(action) {
    const id = action.payload;
  
    let url = buildUrl(BRANDKIT_COLORS_URL, {
      path: id
    });
  
    const fetchingBrandkitColorsAPI = () => {
      return axios.get(url).then(response => response.data);
    }
  
    try {
      const response = yield call(fetchingBrandkitColorsAPI);
      yield put(fetchBrandkitColorsSucceeded(response));
    } catch (error) {
      yield put(fetchingBrandkitColorsFailed(id, error));
    }
  }


/**
 * Update Brankit colors
*/
  export const updateBrandkitColors = createAction(UPDATE_BRANDKIT_COLORS_REQUEST, (id, request) => {
    return {
      id: id,
      request: request
    }
  })
  
  export const updateBrandkitColorsSucceeded = createAction(UPDATING_BRANDKIT_COLORS_SUCCEEDED, (response) => {
    return {
      response: response
    }
  })
  
  export const updateBrandkitColorsFailed = createAction(UPDATING_BRANDKIT_COLORS_FAILED, (id, error) => {
    return {
      id: id,
      error: error
    }
  })
  
  function* updateBrandkitColorsSaga(action) {
    const { id, request } = action.payload;
          
    let url = buildUrl(BRANDKIT_COLORS_URL, {
      path: `/${id}`
    });
  
    const updateBrandkitColorsAPI = () => {
      return axios.put(url, {components: request}).then(response => response.data);
    }
  
    try {
      const response = yield call(updateBrandkitColorsAPI);
      if (response) {
        yield put(updateBrandkitColorsSucceeded(response));
      }
    } catch (error) {
      yield put(updateBrandkitColorsFailed(error));
    }
  }


/**
 * Delete Brandkit colors
*/
  export const deleteBrandkitColors = createAction(DELETE_BRANDKIT_COLORS_REQUEST, (ids, paletteId) => {
    return {
      ids: ids,
      paletteId: paletteId
    }
  }) 
  
  const deleteBrandkitColorsSucceeded = createAction(DELETING_BRANDKIT_COLORS_SUCCEEDED, (ids, response) => {
    return {
      ids: ids,
      response: response
    }
  })
  
  const deleteBrandkitColorsFailed = createAction(DELETING_BRANDKIT_COLORS_FAILED, (ids, error) => {
    return {
      ids: ids,
      error: error
    }
  })
  
  function* deleteBrandkitColorsSaga(action) {
    const {ids, paletteId} = action.payload;
  
    let url = buildUrl(BRANDKIT_COLORS_URL, {
      path: `${paletteId}/component`
    });
  
    const deleteBrandkitColorsAPI = () => {
      return axios.delete(url, {data: ids}).then(response => response.data);
    }
  
    try {
      const response = yield call(deleteBrandkitColorsAPI);
      yield put(deleteBrandkitColorsSucceeded(ids, response));
    } catch (error) {
      yield put(deleteBrandkitColorsFailed(ids, error));
    }
  }

  export const invalidateBrandkitColors = createAction(INVALIDATE_BRANDKIT_COLORS);


export default function* brandkitColorsSaga() {
  yield takeEvery(FETCHING_BRANDKIT_COLORS_REQUEST, fetchingBrandkitColorsSaga);
  yield takeEvery(DELETE_BRANDKIT_COLORS_REQUEST, deleteBrandkitColorsSaga);
  yield takeEvery(UPDATE_BRANDKIT_COLORS_REQUEST, updateBrandkitColorsSaga);
}